"use client";

import type { MutableRefObject } from "react";
import type { TeamDetail } from "@cabal/shared/domain/session/team/types.js";
import type { PersistentDebugLogger } from "@/hooks/telemetry";
import type {
  HomePageInteractionState,
  HomePageModalStateLocal,
} from "./domain/home-page/types";
import {
  useHomePagePreflightLaunchHandlers,
  useHomePageReplicateTeamHandler,
} from "./homePagePreflightHandlerHooks";

interface HomePagePreflightHandlersLocal {
  handleReplicateTeam: (teamConfig: TeamDetail) => void;
  handleStartNewSession: () => void;
  openDeployForTeam: (teamId: string) => void;
}

interface UseHomePagePreflightHandlersInput {
  latestInteractionState: MutableRefObject<HomePageInteractionState>;
  modalDebugLogger: PersistentDebugLogger;
  modalState: Pick<
    HomePageModalStateLocal,
    | "openAuthModal"
    | "showTeamDetailsModal"
    | "showTeamsModal"
    | "teamDetailsTeamId"
  >;
}

export function useHomePagePreflightHandlers({
  latestInteractionState,
  modalDebugLogger,
  modalState,
}: UseHomePagePreflightHandlersInput): HomePagePreflightHandlersLocal {
  const launchHandlers = useHomePagePreflightLaunchHandlers({
    latestInteractionState,
    modalDebugLogger,
    modalState,
  });

  const handleReplicateTeam = useHomePageReplicateTeamHandler({
    modalDebugLogger,
    showTeamDetailsModal: modalState.showTeamDetailsModal,
    showTeamsModal: modalState.showTeamsModal,
    teamDetailsTeamId: modalState.teamDetailsTeamId,
  });

  return {
    handleReplicateTeam,
    handleStartNewSession: launchHandlers.handleStartNewSession,
    openDeployForTeam: launchHandlers.openDeployForTeam,
  };
}
